import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"

interface IconWrapperProps {
  archived: boolean
}

export const IconWrapper = styled.div<IconWrapperProps>`
  background-color: ${({archived}) => archived ? greys.lightest : greys.white};
  border: 1px solid ${greys.light};
  border-radius: 3px;
  width: 30px;
  height: 30px;
  padding: 2px;
  margin: 5px 5px 0 0;
  img {
    width: 25px;
    height: 25px;
    ${({archived}) => archived && "opacity: .3;"}
  }
`
